module.exports = __webpack_public_path__ + "images/wheel-icon-spring-727e4b662afe9a08b0a21cf37b6e702c.png";